import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";

const ORANGE = "#e8973a";
const ORANGE_DARK = "#9c5a12";

// SEO/brand block that lives directly below the video hero on the homepage.
// Houses the page's single <h1>, locality-rich subtitle, two CTAs, and the
// MahaRERA registration badge. Visually a clean, centered intro card — no
// overlay on the video itself.
function HeroContentSection({ sectionSpace = "pt-30 pb-30" }) {
  return (
    <section
      className={`hero-content-section ltn__primary-bg text-color-white ${sectionSpace}`}
      aria-label="Siddhivinayak Group — real estate developer in Nagpur"
    >
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={12} xl={12}>
            <div
              className="hero-content-inner text-center"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: 16,
                padding: "24px 28px",
              }}
            >
              <span
                style={{
                  letterSpacing: ".08em",
                  textTransform: "uppercase",
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#f0a050",
                  margin: 0,
                  display: "block",
                }}
              >
                Kunal Padole Group · RERA Registered · Nagpur
              </span>

              <h1
                style={{
                  fontSize: "clamp(1.75rem, 3.6vw, 2.75rem)",
                  fontWeight: 700,
                  margin: "10px 0 12px",
                  lineHeight: 1.15,
                }}
              >
                Trusted Real Estate Developer in Nagpur
              </h1>

              <p
              className="text-center"
                style={{
                  maxWidth: 760,
                  margin: "0 auto 18px",
                  fontSize: "clamp(0.92rem, 1.4vw, 1.05rem)",
                  lineHeight: 1.55,
                  color: "rgba(255,255,255,.85)",
                }}
              >
                Premium 2 &amp; 3 BHK flats, townships, and RERA-approved RL
                plots in Ram Nagar, Hanuman Nagar, Narsala, Bahadura, and
                Ambazari.
              </p>

              <div
                style={{
                  display: "inline-flex",
                  gap: 16,
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Link
                  href="/projects"
                  className="theme-btn-1 btn btn-effect-1"
                >
                  View Projects
                </Link>
                <span
                  style={{
                    display: "inline-block",
                    padding: "5px 12px",
                    border: `1px solid ${ORANGE}`,
                    borderRadius: 999,
                    color: ORANGE,
                    fontSize: 11,
                    letterSpacing: ".04em",
                    fontWeight: 600,
                  }}
                >
                  RERA No. P50500078967 · MahaRERA Registered
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HeroContentSection;
